import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col text-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "fv-row mb-7" }
const _hoisted_6 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }

import { ref, inject } from "vue";
import UserService from "../../modules/users/services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import Clipboard from "clipboard";
import SendEmail from "./SendEmail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetailsHeader',
  setup(__props) {

const userInfos = inject<any>("userInfos");
const partyId = inject<any>("partyId");
const UserDetailsType = inject<any>("UserDetailsType");
const tab = inject<any>("tab");
const sendEmailRef = ref<any>(null);

const submitted = ref(true);
const requestUserTokenSubmitted = ref(false);
const quizLock = ref(false);

const showSendEmail = (partyId: string) => {
  sendEmailRef.value.show(partyId);
};

const requestUserToken = async () => {
  requestUserTokenSubmitted.value = true;
  try {
    const res = await UserService.requestUserToken(partyId.value);
    MsgPrompt.success(res.message).then(() => {
      Clipboard.copy(
        (process.env.VUE_APP_URL + "set-token?token=" + res.token) as string
      );
      window.open(
        process.env.VUE_APP_URL + "set-token?token=" + res.token,
        "_blank"
      );
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    submitted.value = false;
  }
};

const lockUser = async () => {
  submitted.value = true;
  try {
    const res = await UserService.requestLockUser(partyId.value);
    MsgPrompt.success(res.message);
    userInfos.value.lockoutEnd = new Date();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    submitted.value = false;
  }
};

const unlockUser = async () => {
  submitted.value = true;
  try {
    const res = await UserService.requestUnlockUser(partyId.value);
    MsgPrompt.success(res.message);
    userInfos.value.lockoutEnd = null;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    submitted.value = false;
  }
};

const switchQuizLock = async () => {
  submitted.value = true;
  try {
    const res = await UserService.switchQuizLock(partyId.value);
    MsgPrompt.success(res.message);
    quizLock.value = !quizLock.value;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    submitted.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UserInfo, {
          url: "#",
          user: _unref(userInfos),
          class: "me-2"
        }, null, 8, ["user"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          plain: "",
          type: "primary",
          class: "me-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showSendEmail(_unref(partyId))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.sendEmail")), 1)
          ]),
          _: 1
        }),
        (_ctx.$cans(['TenantAdmin', 'WebGodMode']))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "me-3",
              plain: "",
              type: "danger",
              onClick: requestUserToken
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.requestVisit")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(userInfos).lockoutEnd == null)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "me-3",
              plain: "",
              type: "warning",
              onClick: lockUser
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.lockUser")), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              class: "me-3",
              plain: "",
              type: "success",
              onClick: unlockUser
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.unlockUser")), 1)
              ]),
              _: 1
            })),
        (quizLock.value == true)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              plain: "",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchQuizLock()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.lockQuiz")), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              plain: "",
              type: "success",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (switchQuizLock()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.unlockQuiz")), 1)
              ]),
              _: 1
            }))
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).infos }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (tab.value = _unref(UserDetailsType).infos))
          }, _toDisplayString(_ctx.$t("title.info")), 3)
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).documents }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (tab.value = _unref(UserDetailsType).documents))
          }, _toDisplayString(_ctx.$t("title.documents")), 3)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).applications }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (tab.value = _unref(UserDetailsType).applications))
          }, _toDisplayString(_ctx.$t("title.applications")), 3)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).accounts }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (tab.value = _unref(UserDetailsType).accounts))
          }, _toDisplayString(_ctx.$t("title.account")), 3)
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).wallet }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (tab.value = _unref(UserDetailsType).wallet))
          }, _toDisplayString(_ctx.$t("title.wallet")), 3)
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).paymentInfo }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (tab.value = _unref(UserDetailsType).paymentInfo))
          }, _toDisplayString(_ctx.$t("title.paymentInfos")), 3)
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).socialMedia }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (tab.value = _unref(UserDetailsType).socialMedia))
          }, _toDisplayString(_ctx.$t("title.socialMedia")), 3)
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).config }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (tab.value = _unref(UserDetailsType).config))
          }, _toDisplayString(_ctx.$t("fields.userConfig")), 3)
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).roles }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (tab.value = _unref(UserDetailsType).roles))
          }, _toDisplayString(_ctx.$t("fields.userRoles")), 3)
        ]),
        _createElementVNode("li", _hoisted_16, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).verifyCheck }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (tab.value = _unref(UserDetailsType).verifyCheck))
          }, _toDisplayString(_ctx.$t("title.verification")), 3)
        ]),
        _createElementVNode("li", _hoisted_17, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", { active: _unref(tab) === _unref(UserDetailsType).apiLog }]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (tab.value = _unref(UserDetailsType).apiLog))
          }, "ApiLog", 2)
        ])
      ])
    ]),
    _createVNode(SendEmail, {
      ref_key: "sendEmailRef",
      ref: sendEmailRef
    }, null, 512)
  ], 64))
}
}

})